import * as React from 'react'
import * as classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons'

import * as Style from './style.css'

export interface IProps {
  text: string
  color: 'notice' | 'alert'
  clickhandler?: (() => Promise<void>) | (() => void)
}

export const Indicator = ({
  text,
  color,
  clickhandler,
}: IProps): JSX.Element => (
  <div
    className={classNames({
      [Style.Indicator]: true,
      [Style.IndicatorNotice]: color === 'notice',
      [Style.IndicatorAlert]: color === 'alert',
    })}
    onClick={() => clickhandler && void clickhandler()}
  >
    {color === 'notice' && (
      <FontAwesomeIcon icon={faCircleCheck} className={Style.IndicatorIcon} />
    )}
    {color === 'alert' && (
      <FontAwesomeIcon icon={faCircleXmark} className={Style.IndicatorIcon} />
    )}
    {text}
  </div>
)
